let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b2U0l")).then(() => parcelRequire('ehWCo'));